// src/components/StatCard.js
import React from 'react';
import '../styles/StatCard.css';

const StatCard = ({ title, value, unit, valueKg, change, changeLabel, icon, trend }) => {
  const isPositive = change >= 0;
  
  return (
    <div className={`stat-card glass ${isPositive ? 'trend-positive' : 'trend-negative'}`}>
      <div className="stat-card-header">
        <div className="stat-card-title-container">
          <span className="stat-card-title">{title}</span>
          {icon && <span className="stat-card-icon">{icon}</span>}
        </div>
        {change !== undefined && (
          <div className={`stat-card-badge ${isPositive ? 'positive' : 'negative'}`}>
            <span className="change-arrow">{isPositive ? '↑' : '↓'}</span>
            <span className="change-value">
              {isPositive ? '+' : ''}{change}%
            </span>
          </div>
        )}
      </div>
      
      <div className="stat-card-main">
        <div className="stat-card-value-container">
          <div className="stat-card-value">
            {value}
          </div>
          <span className="stat-card-unit">{unit}</span>
        </div>
        {valueKg !== undefined && (
          <div className="stat-card-value-secondary">
            {valueKg} €/kg
          </div>
        )}
        {changeLabel && (
          <div className="stat-card-label">
            {changeLabel}
          </div>
        )}
      </div>
      
      {trend && (
        <div className="stat-card-trend">
          {trend}
        </div>
      )}
      
      <div className="stat-card-glow"></div>
    </div>
  );
};

export default StatCard;

